function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.6 0.6H0V43.4H42.9V34.8H9.6V0.6ZM71.5 0C61.9 0 53.6 2.9 48.5 8.1C44.8 11.8 42.9 16.7 43 22C43 34 52.5 42.5 67.2 43.8V48.8C67.2 52.6 69.9 55.3 73.7 55.3H91.4V47.3H77.9C76.4 47.3 76.1 47 76.1 45.5V43.7C90.8 42.1 99.9 33.8 99.9 22C100 16.7 98.1 11.9 94.4 8.1C89.3 2.9 80.9 0 71.5 0ZM72 35.4H70.8C61.7 35.4 52.6 31.2 52.6 22C52.6 12.8 61.8 8.6 70.9 8.6H72C81 8.6 90.1 12.8 90.1 22C90.1 31.2 81.1 35.4 72 35.4ZM132.4 0.6H105.9V43.4H132.4C147.2 43.4 156.8 35 156.8 22C156.8 9 147.2 0.6 132.4 0.6ZM131 34.8H115.5V9.2H131C138.3 9.2 147 11.4 147 22C147 32.6 138.4 34.8 131 34.8Z",
  fill: "currentColor"
});
function SvgLqdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 56,
    viewBox: "0 0 157 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLqdLogo);
export default __webpack_public_path__ + "static/media/LQD-logo.4211b320.svg";
export { ForwardRef as ReactComponent };